"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Circle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  color: white;\n  background-color: ", ";\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  color: white;\n  background-color: ", ";\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
    var size = _a.size;
    return (size ? size : '2rem');
}, function (_a) {
    var size = _a.size;
    return (size ? size : '2rem');
}, function (_a) {
    var color = _a.color;
    return (color ? color : '#41cbae');
});
exports.default = Circle;
var templateObject_1;
//# sourceMappingURL=Circle.js.map